<template>
    <Menu
        as="div"
        class="relative inline-block text-left"
        data-spec-class="dropdown_menu"
    >
        <div>
            <MenuButton
                ref="reference"
                data-spec-class="dropdown_menu__toggle"
            >
                <slot />

                <span class="sr-only">Open options</span>
            </MenuButton>
        </div>
        <Teleport to="body">
            <MenuItems
                ref="floating"
                :class="classObjectMenu"
                :style="floatingStyles"
                data-spec-class="dropdown_menu__menu"
            >
                <div class="py-1">
                    <slot name="menu-items" />
                </div>
            </MenuItems>
        </Teleport>
    </Menu>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { Menu, MenuButton, MenuItems } from '@headlessui/vue';
import { autoUpdate, flip, offset, shift, useFloating } from '@floating-ui/vue';

const classObjectMenu = computed(() => ({
    'absolute right-0 z-50 mt-2 w-80 origin-top-right rounded-sm shadow-sm': true,
    'bg-surface--elevated': true,
}));

const reference = ref(null);
const floating = ref(null);
const { floatingStyles } = useFloating(reference, floating, {
    placement: 'bottom-end',
    strategy: 'fixed',
    middleware: [offset(4), flip(), shift()],
    whileElementsMounted: autoUpdate,
});
</script>
